import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
export const imageStyles = ({ theme, $inline, $width, $alignment, $coverContainer, }) => css `
	width: 100%;
	margin-top: ${pxToRem(theme.spacing['100'])};
	margin-bottom: ${pxToRem(theme.spacing['300'])};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	border: 0;

	${$inline &&
    css `
		margin-top: 0;
		margin-bottom: 0;
	`}

	${$width === 'half' &&
    !$coverContainer &&
    css `
		width: 50%;
	`}

    ${$alignment === 'left' &&
    css `
		float: left;
		margin-right: ${pxToRem(theme.spacing['300'])};
	`}

    ${$alignment === 'right' &&
    css `
		float: right;
		margin-right: ${pxToRem(theme.spacing['300'])};
	`}

    ${$coverContainer &&
    css `
		border-radius: 0;
		height: 100%;
		object-fit: cover;
		object-position: center;
		margin-top: 0;
		margin-bottom: 0;
	`}
`;
export const Image = styled.img.withConfig({
    shouldForwardProp: (prop) => !['$inline', '$width', '$alignment', '$coverContainer', 'caption'].includes(String(prop)),
}) `
	${imageStyles}
`;
